import { DEFAULT_AXIS_PROPS, DEFAULT_LINE_PROPS, X_AXIS_HEIGHT } from '../constants';
import {
    COLOR_ACTION_REQUIRED,
    COLOR_ACTIONABLE,
    COLOR_SUCCESS,
    COLOR_TEXT,
} from '../../../components/commander-ui/constants';

export const FULL_OPACITY = 1;
export const MIN_OPACITY = 0.5;

export const PERCENT_AXIS_WIDTH = 85;
export const NUMBER_AXIS_WIDTH = 30;
export const MAX_BAR_SIZE = 20;
export const BAR_CATEGORY_GAP = '20%';
export const CHART_HEIGHT = 140;
export const MIN_BARS_TO_SHOW_LEGEND = 2;

export const COLOR_BAR_NORMAL = COLOR_TEXT;
export const COLOR_BAR_OVERBOOKED = COLOR_ACTION_REQUIRED;
export const COLOR_ARRIVALS = COLOR_ACTIONABLE;
export const COLOR_DEPARTURES = COLOR_SUCCESS;

export const OCCUPANCY_UNIT = '%';

export const CONTAINER_PROPS = {
    height: CHART_HEIGHT,
};

const lineProps = {
    ...DEFAULT_LINE_PROPS,
    yAxisId: 'right',
};

export const ARRIVALS_LINE_PROPS = {
    ...lineProps,
    dataKey: 'arrivals',
    stroke: COLOR_ARRIVALS,
};

export const DEPARTURES_LINE_PROPS = {
    ...lineProps,
    dataKey: 'departures',
    stroke: COLOR_DEPARTURES,
};

export const X_AXIS_PROPS = {
    ...DEFAULT_AXIS_PROPS,
    height: X_AXIS_HEIGHT,
    dataKey: 'date',
    hide: true,
};

export const PERCENT_AXIS_PROPS = {
    ...DEFAULT_AXIS_PROPS,
    width: PERCENT_AXIS_WIDTH,
    tickFormatter: (value: $TSFixMe) => `${value} %`,
};

export const NUMBER_AXIS_PROPS = {
    ...DEFAULT_AXIS_PROPS,
    orientation: 'right',
    yAxisId: 'right',
    width: NUMBER_AXIS_WIDTH,
    allowDecimals: false,
};
